export const blockIconsContentRemove = (
	<span className='material-symbols-outlined'>remove</span>
);
